import { Grid, Typography } from '@mui/material';
import { ORBIT_CHANNEL_META, OrbitChannelEnum } from './formData';

type Props = {
    channel: string;
};

export const OrbitFormHeader = ({ channel }: Props) => {
    if (!channel) return null;

    const meta = ORBIT_CHANNEL_META[channel as OrbitChannelEnum];
    if (!meta) return null;

    return (
        <>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography sx={{ fontWeight: 'bold', color: '#000' }}>
                    {meta.title}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography sx={{ color: 'text.secondary' }}>
                    {meta.description}
                </Typography>
            </Grid>
        </>
    );
};
